import axios_http from "axios";
const axios = axios_http;

/* eslint-disable */
export default {
  namespaced: true,
  state: {
    token: null,
    user: null,
    error_msg: null,
    favorite: null,
  },

  getters: {
    authenticated(state) {
      return state.token && state.user;
    },
    user(state) {
      return state.user;
    },
    favorite(state) {
      return state.favorite;
    },
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_USER(state, data) {
      state.user = data;
    },
    SET_FAVORITE(state, data) {
      state.favorite = data;
    },
  },

  actions: {
    async signIn({ dispatch }, credentials) {
      let response = await axios.post(
        "https://rtm.glueapi.io/v1/user-session",
        credentials
      );

      localStorage.setItem("user_id", response.data.data.idUser);

      return dispatch("attempt", response.data.data.token);
    },

    async FBsignIn({ dispatch }, credentials) {
      let response = await axios.post(
        "https://rtm.glueapi.io/v1/oauthfacebook/callback",
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      localStorage.setItem("user_id", response.data.data.idUser);

      return dispatch("attempt", response.data.data.token);
    },

    async GoogleSignIn({ dispatch }, credentials) {
      let response = await axios.post(
        "https://rtm.glueapi.io/v1/oauthgoogle/callback",
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      localStorage.setItem("user_id", response.data.data.idUser);

      return dispatch("attempt", response.data.data.token);
    },

    async attempt({ commit, state }, token) {
      if (token) {
        commit("SET_TOKEN", token);
      }

      if (!state.token) {
        return;
      }

      const userID = localStorage.getItem("user_id");
      try {
        let response = await axios.get(
          `https://rtm.glueapi.io/v3/user/${userID}/`,
          {
            headers: {
              "X-AUTH-TOKEN": token,
              "Content-Type": "application/json",
            },
          }
        );

        let favorite = await axios.get(
          `https://rtm.glueapi.io/v1/user/${userID}/content/favourite?limit=300&fields=title,slug,data.image,data.categories,data.classification,idSchema`,
          {
            headers: {
              "X-AUTH-TOKEN": token,
              "Content-Type": "application/json",
            },
          }
        );

        if (favorite && favorite != null) {
          localStorage.setItem("setFavorite", "true");
        }
        commit("SET_USER", response.data);
        commit("SET_FAVORITE", favorite);

        // SET_FAVORITE
      } catch (err) {
        commit("SET_TOKEN", null);
        commit("SET_USER", null);
        commit("SET_FAVORITE", null);
        localStorage.removeItem("setFavorite");
        localStorage.removeItem("user_id");
      }
    },

    signOut({ commit }) {
      commit("SET_TOKEN", null);
      commit("SET_USER", null);
      commit("SET_FAVORITE", null);
      localStorage.removeItem("user_id");
      window.location.reload(true);
      return;
    },
  },
};
